import React, { useState } from 'react';
import { TextField, CircularProgress } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { buscarUbigeo } from '../utils/ubigeo';

export default function UbigeoAutocomplete({ value, onChange, label = 'Ubigeo', ...props }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');

  React.useEffect(() => {
    // Si value es string/código, buscar el objeto completo
    if (typeof value === 'string' && value.length === 6) {
      (async () => {
        const { obtenerUbigeoPorCodigo } = await import('../utils/ubigeo');
        const obj = await obtenerUbigeoPorCodigo(value);
        if (obj) onChange(obj);
      })();
    }
  }, [value]);

  const handleInputChange = async (event, newInputValue) => {
    setInputValue(newInputValue);
    if (!newInputValue || newInputValue.length < 3) {
      setOptions([]);
      return;
    }
    setLoading(true);
    const results = await buscarUbigeo(newInputValue);
    setOptions(results);
    setLoading(false);
  };

  return (
    <Autocomplete
      options={options}
      getOptionLabel={option => option && option.codigo ? `${option.codigo} - ${option.departamento}, ${option.provincia}, ${option.distrito}` : ''}
      value={value && value.codigo ? value : null}
      inputValue={inputValue}
      onInputChange={handleInputChange}
      onChange={(event, newValue) => onChange(newValue)}
      loading={loading}
      filterOptions={(x) => x}
      renderInput={params => (
        <TextField {...params} label={label} variant="outlined" fullWidth InputProps={{
          ...params.InputProps,
          endAdornment: (
            <>
              {loading ? <CircularProgress color="inherit" size={20} /> : null}
              {params.InputProps.endAdornment}
            </>
          ),
        }} />
      )}
      {...props}
    />
  );
}
